import React from "react";
import Loader from "react-loader-spinner";

export const Spinner = () => {
  return (
    <Loader
      type="Puff"
      color="#4e4e4e"
      style={{
        position: "absolute",
        zIndex: "1213213",
        top: "0%",
        left: "0%",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        overFlow: "hidden",
      }}
      className="d-flex align-items-center justify-content-center w-100 h-100"
    />
  );
};
